import { axiosWithHeaders } from '@innovyze/lib_get_service';
import config from './config.api';

const costService = axiosWithHeaders({
  service: 'saasAmCost',
  config,
  axiosCreateOpts: { timeout: 30000 },
});

export default costService;
